import React, { Component } from 'react';
import './index.scss';
import { connect } from 'react-redux';
import { I18n, Translate } from 'react-redux-i18n';
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import ButtonMui from '@material-ui/core/Button';
import DialogActions from '@material-ui/core/DialogActions';
import { MenuItem, Select, Switch } from '@material-ui/core';
import Alert from '../../../../Components/Alert';
import {
	EDIT_MAPPING_PLACE_SEND,
	SAVE_MAPPING_PLACE_SEND,
} from './service/type';
import { confirm } from '../../../../utils';

class MappingPlaceSend extends Component {
	constructor(props) {
		super(props);
		this.state = {
			open: false,
			mappingModeFloor: true,
		};
	}

	openModal = () => {
		this.setState({
			open: true,
			product_threshold: this.props.threshold,
			active: this.props.active,
		});
	};

	closeModal = () => {
		this.setState({
			open: false,
		});
	};

	isMappingModeFloor = _ => {
		return (
			this.state.mappingModeFloor &&
			!this.props.mapping.filter(m => m.prefix == this.props.prefix && !m.floor)
				.length
		);
	};

	onChange = (id_source, id_place_send_target) => {
		const mappingModeFloor = this.isMappingModeFloor();
		let _mapping = JSON.parse(JSON.stringify(this.props.mapping));
		const keyMapping = mappingModeFloor ? 'floor' : 'id_place_send_source';

		if (!id_place_send_target) {
			_mapping = _mapping.filter(m => {
				if (m.prefix == this.props.prefix && m[keyMapping] == id_source)
					return false;
				return true;
			});
		} else if (
			_mapping.find(
				m => m.prefix == this.props.prefix && m[keyMapping] == id_source
			)
		) {
			_mapping = _mapping.map(m => {
				if (m.prefix == this.props.prefix && m[keyMapping] == id_source)
					m.id_place_send_target = id_place_send_target;
				return m;
			});
		} else {
			_mapping.push({
				prefix: this.props.prefix,
				id_place_send_source: null,
				id_place_send_target,
				floor: null,
				[keyMapping]: id_source,
			});
		}

		this.props.patch(_mapping);
	};

	onChangeMappingMode = e => {
		const checked = e.target.checked;
		if (this.props.mapping.filter(m => m.prefix == this.props.prefix).length) {
			confirm(I18n.t('place_send.reset_confirm')).then(
				() => {
					this.props.patch(
						this.props.mapping.filter(m => m.prefix !== this.props.prefix)
					);
					this.setState({ mappingModeFloor: checked });
				},
				() => {
					this.setState({ mappingModeFloor: !checked });
				}
			);
		} else {
			this.props.patch(
				this.props.mapping.filter(m => m.prefix !== this.props.prefix)
			);
			this.setState({ mappingModeFloor: checked });
		}
	};

	render() {
		const mappingModeFloor = this.isMappingModeFloor();

		const mappingSource = mappingModeFloor
			? this.props.floor
			: this.props.places_send.filter(ps => ps.removed == 0);
		const keyMapping = mappingModeFloor ? 'floor' : 'id_place_send_source';

		return (
			<div className="gestion-button-container">
				<div>
					<ButtonMui onClick={this.openModal} variant={'outlined'}>
						<Translate value={'place_send.button'} />
					</ButtonMui>
					<Dialog
						onClose={this.closeModal}
						open={this.state.open}
						id={'dialog-payment-types'}>
						<DialogTitle>
							<Translate value={'place_send.title'} />
						</DialogTitle>
						<DialogContent>
							<Alert type="info">
								{mappingModeFloor
									? I18n.t('place_send.info_floor')
									: I18n.t('place_send.info')}
							</Alert>

							{!this.props.places_send.length ? (
								<div style={{ marginTop: 20 }}>
									<Alert type="warning">{I18n.t('place_send.empty')}</Alert>
								</div>
							) : (
								<div className="mapping-place-send-container">
									{this.props.places_send.filter(ps => ps.removed == 0) ? (
										<p>
											<span>{I18n.t('place_send.switch_place_send')}</span>
											<Switch
												checked={mappingModeFloor}
												onChange={this.onChangeMappingMode}
											/>
											<span>{I18n.t('place_send.switch_floor')}</span>
										</p>
									) : null}

									<div className="mapping-place-send-title">
										<span>
											{mappingModeFloor
												? I18n.t('place_send.floor')
												: I18n.t('place_send.place_send')}
										</span>
										<span>{' : '}</span>
										<span>{I18n.t('place_send.place_send')}</span>
									</div>
									{mappingSource.map(ps => {
										let link = this.props.mapping.find(
											m =>
												m.prefix == this.props.prefix && m[keyMapping] === ps.id
										);
										return (
											<div className="mapping-place-send-row">
												{' '}
												<span>{ps.name}</span>
												<span className="mapping-place-send-row-separator">
													{' '}
													:{' '}
												</span>
												<Select
													value={link ? link.id_place_send_target : ''}
													onChange={e => {
														this.onChange(ps.id, e.target.value);
													}}
													displayEmpty>
													<MenuItem key="000" value={''}>
														<i>{I18n.t('binding.default')}</i>
													</MenuItem>
													{this.props.places_send
														.filter(p => p.id !== ps.id) // on ne va pas bind un lieu d'envoi avec lui meme...
														.filter(
															// on affiche que ceux qui sont removed == 0 sauf si il y a un mapping
															p =>
																p.removed == 0 ||
																(p.removed &&
																	link &&
																	link.id_place_send_target == p.id)
														)
														.map((p, i) => (
															<MenuItem key={i} value={p.id}>
																{p.name} -{' '}
																<span style={{ fontStyle: 'italic' }}>
																	{p.devices.length}{' '}
																	{I18n.t(
																		p.devices.length > 1
																			? 'place_send.printers'
																			: 'place_send.printer'
																	)}
																	{p.removed
																		? ` (${I18n.t('place_send.removed')})`
																		: ''}
																</span>
															</MenuItem>
														))}
												</Select>
											</div>
										);
									})}
								</div>
							)}
						</DialogContent>
						<DialogActions>
							{' '}
							<ButtonMui onClick={this.closeModal}>
								<Translate value={'general.close'} />
							</ButtonMui>
							<ButtonMui
								onClick={() => this.props.save(this.props.mapping)}
								color="primary"
								autoFocus>
								<Translate value={'general.valid'} />
							</ButtonMui>
						</DialogActions>
					</Dialog>
				</div>
			</div>
		);
	}
}

const mapStateToProps = (state, props) => {
	const { binding } = state;

	return {
		places_send: binding.placeSend,
		floor: binding.floorAll,
		mapping: binding.placeSendMapping,
	};
};

const mapDispatchToProps = dispatch => {
	return {
		patch: mapping => dispatch({ type: EDIT_MAPPING_PLACE_SEND, mapping }),
		save: mapping =>
			dispatch({
				type: SAVE_MAPPING_PLACE_SEND,
				mapping,
			}),
	};
};
export default connect(mapStateToProps, mapDispatchToProps)(MappingPlaceSend);
